export default __webpack_public_path__ + "images/7b9a8a41aa462e6d77f881d23fcdca4f-getDiscovered.webp";